import styled from 'styled-components';

export const UserProfileSection = styled.div`
  display: flex;
  align-items: flex-start;
  column-gap: 10px;
`;

export const UserImage = styled.img`
  width: 32px;
  height: 32px;
  border-radius: 50%;
`;

export const MotherName = styled.p`
  font-size: 14px;
  font-weight: 500;
  color: hsl(0deg, 0%, 0%, 80%);
`;
